import React from 'react'
import { InputType } from './Input.type'
import './input.scss'
import { useTranslation } from 'react-i18next'

const Input:React.FC<InputType> = ({
  label, className, errorMessage, otherProps, valid = true,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`input ${valid ? 'input__invalid' : ''} ${className || ''}`}>
      {label && <label className={'input__label'}>{label}</label>}
      <input
        {...otherProps}
      />
      {!valid
                && <span className={'input__error-message'}>{errorMessage || t('requiredField')}</span>}
    </div>
  )
}

export default Input
